"use strict";
exports.__esModule = true;
exports.SliceType = void 0;
var SliceType;
(function (SliceType) {
    SliceType["AnchorList"] = "anchor_list";
    SliceType["ArticleList"] = "article_list";
    SliceType["BannerCta"] = "banner_cta";
    SliceType["BulleTalk"] = "bulle_talk";
    SliceType["CardList"] = "card_list";
    SliceType["Charts"] = "charts";
    SliceType["ContactList"] = "contact_list";
    SliceType["ContainerWithLeftMenu"] = "container_with_left_menu";
    SliceType["Cta"] = "cta";
    SliceType["Divider"] = "divider";
    SliceType["DocumentList"] = "document_list";
    SliceType["DownloadLinks"] = "download_links";
    SliceType["Event"] = "event";
    SliceType["EventList"] = "event_list";
    SliceType["Exergue"] = "exergue";
    SliceType["FinancialMatrix"] = "financial_matrix";
    SliceType["Footnotes"] = "footnotes";
    SliceType["Grid"] = "grid";
    SliceType["Heading2"] = "heading_2";
    SliceType["Headnote"] = "headnote";
    SliceType["Hub"] = "hub";
    SliceType["Image"] = "image";
    SliceType["Insert"] = "insert";
    SliceType["Interview"] = "interview";
    SliceType["InvestorsDashboard"] = "investors_dashboard";
    SliceType["InvestorsRedirectBlock"] = "investors_redirect_block";
    SliceType["InvestorsPressRelease"] = "investors_press_release";
    SliceType["InvestorsTabs"] = "investors_tabs";
    SliceType["KeyFigure"] = "key_figure";
    SliceType["KeyNumbers"] = "key_numbers";
    SliceType["LargeCardGrid"] = "large_card_grid";
    SliceType["List"] = "list";
    SliceType["Notation"] = "notation";
    SliceType["NotationPictoList"] = "notation_picto_list";
    SliceType["Podcast"] = "podcast";
    SliceType["PodcastVisual"] = "podcast_visual";
    SliceType["PressReleaseList"] = "press_release_list";
    SliceType["Profile"] = "profile";
    SliceType["ProfileList"] = "profile_list";
    SliceType["PublicationList"] = "publication_list";
    SliceType["Quote"] = "quote";
    SliceType["ResultHistoryInvestors"] = "result_history_investors";
    SliceType["RegulatedInformation"] = "regulated_information";
    SliceType["RelatedArticles"] = "related_articles";
    SliceType["RSEDocumentList"] = "rse_document_list";
    SliceType["SizeableHeading2"] = "sizeable_heading_2";
    SliceType["SliderHero"] = "slider_hero";
    SliceType["SliderVisuals"] = "slider_visuals";
    SliceType["Table"] = "table";
    SliceType["Text"] = "text";
    SliceType["TextWithImage"] = "text_with_image";
    SliceType["TextWithProfile"] = "text_with_profile";
    SliceType["TextWithBulleTalk"] = "text_with_bulle_talk";
    SliceType["TextWithVisualCarousel"] = "text_with_visual_carousel";
    SliceType["TileGrid"] = "tile_grid";
    SliceType["TwitterCarousel"] = "twitter_carousel";
    SliceType["Verbatim"] = "verbatim";
    SliceType["Video"] = "video";
    SliceType["VideoHero"] = "video_hero";
})(SliceType = exports.SliceType || (exports.SliceType = {}));
//# sourceMappingURL=slice-type.js.map